import { render, staticRenderFns } from "./IconTip.vue?vue&type=template&id=7fd5db6a&"
import script from "./IconTip.vue?vue&type=script&lang=js&"
export * from "./IconTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports